import DepositGroupsDetals from "./depositGroupsDetals";

export default DepositGroupsDetals;